import { render, staticRenderFns } from "./proposal.vue?vue&type=template&id=fe51dd4a&scoped=true&"
import script from "./proposal.vue?vue&type=script&lang=ts&"
export * from "./proposal.vue?vue&type=script&lang=ts&"
import style0 from "./proposal.vue?vue&type=style&index=0&id=fe51dd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe51dd4a",
  null
  
)

export default component.exports